import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setMfpartyFilterCriteria } from 'store/slice/ManufSlice';

export default function MfpartyFilterCriteria() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.manufslice.mfpartyDashboard);
    
    
const updateTitleCriteria = (title) =>{
        dispatch(setMfpartyFilterCriteria(
            {
                ...filterCriteria,
                title:title
        }))
    }
const updateMobileCriteria = (mobile) =>{
        dispatch(setMfpartyFilterCriteria(
            {
                ...filterCriteria,
                mobile:mobile
        }))
    }

    return (

        <Grid container direction="row" lg={12} sx={{justifyContent:'center'}}>
                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Title"
                            name="title"
                            value={filterCriteria.title}
                            onChange={(e)=>updateTitleCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Mobile"
                            name="mobile"
                            value={filterCriteria.mobile}
                            onChange={(e)=>updateMobileCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>


        </Grid>
    )

}